import { GenericAdapter } from '@mode-switch/adapt';
import { FlamingoCatalog } from './FlamingoCatalog';
export class FlamingoAdapter extends GenericAdapter {
    catalog() {
        return new FlamingoCatalog();
    }
}
